import {
    GET_ALL_APPLICATION_SERVICES_BEGIN, GET_ALL_APPLICATION_SERVICES_SUCCESS, GET_ALL_APPLICATION_SERVICES_FAILURE,
    POST_APPLICATION_SERVICE_BEGIN, POST_APPLICATION_SERVICE_SUCCESS, POST_APPLICATION_SERVICE_FAILURE
} from '../constants/ActionTypes'

const initialState = {

    // Get All Application Services
    allApplicationServices: null,
    isLoadingAllApplicationServices: false,
    hasErrorAllApplicationServices: null,

    // Post Application Service
    createdApplicationService: null,
    isCreatingApplicationService: false,
    hasErrorCreatedApplicationService: null,
}

/**
 * @description Reducer function for managing application services state.
 *
 * @author Maria Eduarda Franke
 * @param {Object} state - The current state of the application services.
 * @param {Object} action - The action object that contains the type and payload.
 * @returns {Object} - The new state of the application services.
 */
const ReducerApplicationService = (state = initialState, action) => {
    switch (action.type) {

    // Get All Application Services
    case GET_ALL_APPLICATION_SERVICES_BEGIN: {
        return {
            ...state,
            isLoadingAllApplicationServices: true
        }
    }
    case GET_ALL_APPLICATION_SERVICES_SUCCESS: {
        return {
            ...state,
            allApplicationServices: action.payload,
            isLoadingAllApplicationServices: false,
            hasErrorAllApplicationServices: null
        }
    }
    case GET_ALL_APPLICATION_SERVICES_FAILURE: {
        return {
            ...state,
            allApplicationServices: null,
            isLoadingAllApplicationServices: false,
            hasErrorAllApplicationServices: action.payload
        }
    }

    // Post Application Service
    case POST_APPLICATION_SERVICE_BEGIN: {
        return {
            ...state,
            isCreatingApplicationService: true
        }
    }
    case POST_APPLICATION_SERVICE_SUCCESS: {
        return {
            ...state,
            createdApplicationService: action.payload,
            isCreatingApplicationService: false,
            hasErrorCreatedApplicationService: null
        }
    }
    case POST_APPLICATION_SERVICE_FAILURE: {
        return {
            ...state,
            createdApplicationService: null,
            isCreatingApplicationService: false,
            hasErrorCreatedApplicationService: action.payload
        }
    }

    default: return state

    }
}

export default ReducerApplicationService